import { useContext, useEffect, useState } from "react"

import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import CardHorario from "./CardHorario/CardHorario"
import { Button } from "@mui/material"
import EdicaoHorario from "./EdicaoHorario/EdicaoHorario"
import { OneSwitch } from "../../../../../Components/OneSwitch/OneSwitch"
import OneSelect from "../../../../../Components/OneSelect/OneSelect"
import CardEventoExceto from "./CardEventoExceto/CardEventoExceto"
import EdicaoEventosExcetos from "./EdicaoEventosExcetos/EdicaoEventosExcetos"

const HorariosAba = ({ setOpenCadastro, idCentral, idCond }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [horarioList, setHorarioList] = useState(null)
    const [loading, setLoading] = useState(true)

    const [idToEdit, setIdToEdit] = useState(null)

    const [openHorario, setOpenHorario] = useState(false)
    const [openEventoExceto, setOpenEventoExceto] = useState(false)

    const [equipes, setEquipes] = useState(null)
    const [equipeHibrida, setEquipeHibrida] = useState(null)
    const [eventosExceto, setEventosExceto] = useState(null)
    const [condEventosExceto, setCondEventosExceto] = useState(null)
    const [mudarEquipeHibrida, setMudarEquipeHibrida] = useState(null)

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setHorarioList(msg.data.horario.horario_hibrido)
            setEquipeHibrida(msg.data.horario.id_equipe_hibrida)
            setCondEventosExceto(msg.data.horario.eventos_exceto_hibrida)
            setMudarEquipeHibrida(msg.data.horario.mudar_equipe_hibrida)
            // setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    addRoute("editarHorarioHibrido", (msg) => {
        if (msg.data.status) {
            showNotify("success", "Horário editado com sucesso")
            setOpenHorario(false)
            sendWs("buscarHorarioHibrido", { id_central: idCentral })
        } else {
            showNotify("error", msg.message)
        }
    })

    const montaDescricaoEvento = () => {
        const condEventosExcetoCopy = []
        condEventosExceto.map((evento) => {
            const eventoExceto = eventosExceto.find((eventoLista) => eventoLista.evento == evento.evento)
            if (eventoExceto) {
                condEventosExcetoCopy.push({ ...evento, descricao: `${evento.evento} - ${eventoExceto.descricao}` })
            }
        })
        setCondEventosExceto(condEventosExcetoCopy)
        setLoading(false)
    }

    useEffect(() => {
        if (condEventosExceto && eventosExceto.length > 0) {
            montaDescricaoEvento()
        } else {
            setLoading(false)
        }
    }, [eventosExceto])

    const getEquipesEventos = (msg) => {
        if (msg.data.status) {
            setEquipes(msg.data.listagens.equipe)
            const eventosLista = msg.data.listagens.evento.filter((evento) => evento.vai_para_tela == 1 && evento.descartar == 0)
            setEventosExceto(eventosLista)
        } else {
            showNotify(msg.message)
        }
    }

    useEffect(() => {
        if (!openHorario && !openEventoExceto) {
            setTimeout(() => {
                setLoading(true)
                addRoute("buscarHorarioHibrido", getDadosIniciais)
                sendWs("buscarHorarioHibrido", { id_central: idCentral })
                sendWs("buscarListagens", { listagens: { equipe: ["id", "descricao"], evento: ["id", "evento", "descricao", "vai_para_tela", "descartar"] } })
                addRoute("buscarListagens", getEquipesEventos)
            }, 100)
        }
    }, [openEventoExceto, openHorario])

    const deleteHorario = (index) => {
        const horarioListCopy = horarioList
        horarioListCopy.splice(index, 1)
        setLoading(true)
        sendWs("editarHorarioHibrido", { horario: horarioListCopy, id_central: idCentral })
    }

    const handleChangeEquipe = (equipe) => {
        sendWs("editarCondominio", { condominio: { id: idCond, id_equipe_hibrida: equipe.target.value } })
        setEquipeHibrida(equipe.target.value)
    }

    const deleteEventoExceto = (index) => {
        const eventosExcetoCopy = condEventosExceto
        eventosExcetoCopy.splice(index, 1)
        const condEventosExcetoCopy = condEventosExceto.map((evento) => {
            return { evento: evento.evento, porteiro: evento.porteiro }
        })
        sendWs("editarCondominio", { condominio: { id: idCond, eventos_exceto_hibrida: JSON.stringify(condEventosExcetoCopy) } })
        setCondEventosExceto(eventosExcetoCopy)
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    const changePorteiroEventosExceto = (indexEvento, value) => {
        condEventosExceto[indexEvento].porteiro = value ? 1 : 0
        const condEventosExcetoCopy = condEventosExceto.map((evento) => {
            return { evento: evento.evento, porteiro: evento.porteiro }
        })
        sendWs("editarCondominio", { condominio: { id: idCond, eventos_exceto_hibrida: JSON.stringify(condEventosExcetoCopy) } })
    }

    return (
        <>
            {equipes && (mudarEquipeHibrida != null) &&
        <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: '20%', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button color="one_primary" variant="contained" onClick={() => { setIdToEdit(null); setOpenHorario(true) }} >Novo horário</Button>
                <span style={{ fontSize: '14px' }}>* Horários em que não haverá monitoramento (Não irá gerar evento)</span>
            </div>
            {openHorario &&
            <EdicaoHorario
                openHorario={openHorario}
                setOpenHorario={setOpenHorario}
                indexToEdit={idToEdit}
                horarioToEdit={horarioList[idToEdit]}
                setIdToEdit={setIdToEdit}
                idCentral={idCentral}
                horarios={horarioList}
            />
            }
            {openEventoExceto &&
            <EdicaoEventosExcetos
                openEventoExceto={openEventoExceto}
                setOpenEventoExceto={setOpenEventoExceto}
                condEventosExceto={condEventosExceto || []}
                eventosExceto={eventosExceto}
                idCond={idCond}
            />
            }
            <div style={{ height: '70%', width: '100%', textAlign: 'center' }}>

                {(!loading)
                    ? (horarioList.length > 0
                        ? horarioList.map((horario, index) => {
                            return (
                                <CardHorario
                                    key={index}
                                    id={horario}
                                    index={index}
                                    horario={horario}
                                    idCentral={idCentral}
                                    setIdToEdit={setIdToEdit}
                                    setOpenHorario={setOpenHorario}
                                    deleteHorario={deleteHorario}
                                />
                            )
                        })
                        : <span>Nenhum horário cadastrado</span>)
                    : (<span>Carregando...</span>)
                }
                <hr/>
            </div>
            <div style={{ height: '10%', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {equipes.length > 0
                    ? (
                        <><div>
                            <OneSwitch
                                color="one_primary"
                                variant="contained"
                                defaultValue={mudarEquipeHibrida == 1}
                                onChange={(e) => {
                                    sendWs("editarCondominio", { condominio: { id: idCond, mudar_equipe_hibrida: e.target.checked } })
                                    setMudarEquipeHibrida(e.target.checked)
                                }}
                            >Novo horário</OneSwitch>
                            <span style={{ fontSize: '14px', marginLeft: '3px' }}>* Nesses horários gerar eventos para a equipe: </span>
                        </div>
                        <div style={{ width: '50%' }}>
                            <OneSelect
                                options={equipes}
                                defaultValue={equipeHibrida || 0}
                                onChange={handleChangeEquipe}
                                name={"id_equipe"}
                                disabled={mudarEquipeHibrida == 0}
                            />
                        </div> </>)
                    : <span style={{ fontSize: '14px', marginLeft: '3px' }}>* Para habilitar a opção de gerar evento para outra
                    equipe é necessário existir equipes no sistema </span>
                }
            </div>
            <hr/>
            <div style={{ height: '10%', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button color="one_primary" variant="contained" onClick={() => { setIdToEdit(null); setOpenEventoExceto(true) }} >Novo evento</Button>
                <span style={{ fontSize: '14px' }}>* Exceto para os eventos abaixo, que serão encaminhados para a equipe padrão do condomínio.</span>
            </div>
            <div style={{ height: '70%', width: '100%', textAlign: 'center' }}>

                {(!loading)
                    ? (condEventosExceto && condEventosExceto.length > 0
                        ? condEventosExceto.map((evento, index) => {
                            return (
                                <CardEventoExceto
                                    key={index}
                                    id={evento.evento}
                                    index={index}
                                    eventoExceto={evento}
                                    idCentral={idCentral}
                                    setIdToEdit={setIdToEdit}
                                    setOpenEventoExceto={setOpenEventoExceto}
                                    deleteEventoExceto={deleteEventoExceto}
                                    editPorteiro={changePorteiroEventosExceto}
                                />
                            )
                        })
                        : <span>Nenhuma exceção cadastrado</span>)
                    : (<span>Carregando...</span>)
                }
            </div>
        </div>
            }
        </>
    )
}

export default HorariosAba
